export default {
  unlocked_plural: '{{count}} ofertas foram desbloqueadas',
  unlocked: '{{offer}} oferta foi desbloqueada',
  removed_one: '{{offer}} oferta foi removida',
  removed_other: '{{count}} foram removidas',
};
